/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class TimePickerHour extends React.Component {
    constructor(props) {
        super(props);

        this.getHourValues = this.getHourValues.bind(this);
        this.changeHandler = this.changeHandler.bind(this);

    }


    getHourValues() {
        let start = this.props.twelveHourTime ? 1 : 0,
            end = this.props.twelveHourTime ? 12 : 24,
            ret = [];

        while (start <= end) {
            ret.push(start);
            start++;
        }

        return ret;

    }

    changeHandler(e) {
        let hour = e.currentTarget.value,
            oldTimeMoment = moment(this.props.scheduleTime),
            newTimeMoment = moment(this.props.scheduleTime).hour(hour),
            oldTime = oldTimeMoment.format('HH:mm:ss'),
            newTime = newTimeMoment.format('HH:mm:ss'),
            meridiem = oldTimeMoment.format('A');

        newTimeMoment = moment(newTime + ' ' + meridiem, ['HH:mm:ss A']);
        newTime = newTimeMoment.format('HH');

        e.preventDefault();

        this.props.changeHandler(newTime, e);

    }

    shouldComponentUpdate(nextProps, nextState) {

        if (nextProps.scheduleTime !== undefined && (this.props.scheduleTime !== undefined && this.props.scheduleTime !== null)) {
            if (nextProps.scheduleTime.format('h') == this.props.scheduleTime.format('h')) {
                return false;
            }
        }

        return true;

    }

    render() {
        let timezone = this.props.user.detail.timezone,
            time = this.props.offset ? moment.tz(this.props.scheduleTime, timezone) : moment(this.props.scheduleTime),
            hour = time.format('h'),
            hours = this.getHourValues(),
            hourOptions = hours.map((val, i) => {
                return (
                    <option value={val} key={'hour-' + this.props.scheduleTime + '-' + val}>{val}</option>
                );
            });

        return (<select className="dlvr-select time-picker" value={hour} onChange={this.changeHandler} data-field="hours">
            {hourOptions}
        </select>);

    }

};

TimePickerHour.propTypes = {
    scheduleTime: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    twelveHourTime: PropTypes.bool,
    changeHandler: PropTypes.func
};

TimePickerHour.defaultProps = {
    offset: true,
    scheduleTime: moment().toISOString(),
    twelveHourTime: true,
    changeHandler: null
};

export default TimePickerHour;
